<template>
  <div>
    <div
      v-if="show_filters"
      class="deals-filter-toggle mb-1"
      @click="$emit('toggle_filters')"
    >
      <feather-icon :icon="filters_open ? 'ChevronUpIcon' : 'SlidersIcon'" size="14" class="mr-05" />
      <span class="avenir-medium">{{ $t(is_private ? 'creator.filterDealsCustom' : 'creator.filterDeals') }}</span>
      <b-badge v-if="has_active_filters" variant="light-primary" pill class="ml-05">{{ active_filter_count }}</b-badge>
    </div>

    <b-collapse v-if="show_filters" :visible="filters_open">
      <deals-filter
        @filter_change="$emit('filter_change', $event)"
        class="mb-2"
      />
    </b-collapse>

    <deals-list-section
      :texts="texts"
      :loading="loading"
      :proposals="proposals"
      :selected_deal_radio="selected_deal_radio"
      :is_in_sidebar="is_in_sidebar"
      :is_avaible_to_editing="is_avaible_to_editing"
      :current_page="current_page"
      :total_rows="total_rows"
      :per_page="per_page"
      :is_brandme_talent="is_brandme_talent"
      :chat_uuid="chat_uuid"
      @update:selected_deal_radio="$emit('update:selected_deal_radio', $event)"
      @deal_selected="$emit('deal_selected', $event)"
      @edit_deal="forwardEditDeal"
      @update_current_page="$emit('update_current_page', $event)"
      @delete_deal="$emit('delete_deal', $event)"
    />
  </div>
</template>

<script>
import { BCollapse, BBadge } from 'bootstrap-vue';
import DealsListSection from '@/views/pages/proposals/stepper/viewProposals/components/DealsListSection.vue';

export default {
  name: 'DealsSectionWithFilters',
  components: {
    BCollapse,
    BBadge,
    DealsListSection,
    DealsFilter: () => import('@/views/pages/proposals/stepper/viewProposals/components/DealsFilter.vue'),
  },
  props: {
    texts: {
      type: Object,
      default: () => ({
        title: 'Paquetes',
        description: '',
      }),
    },
    loading: {
      type: Boolean,
      default: false,
    },
    proposals: {
      type: Array,
      default: () => [],
    },
    selected_deal_radio: {
      type: Object,
      default: () => ({ price: 0, licensing: null }),
    },
    is_in_sidebar: {
      type: Boolean,
      default: false,
    },
    is_avaible_to_editing: {
      type: Boolean,
      default: false,
    },
    current_page: {
      type: Number,
      default: 1,
    },
    total_rows: {
      type: Number,
      default: 0,
    },
    per_page: {
      type: Number,
      default: 5,
    },
    is_brandme_talent: {
      type: Boolean,
      default: false,
    },
    chat_uuid: {
      type: String,
      default: null,
    },
    show_filters: {
      type: Boolean,
      default: false,
    },
    filters_open: {
      type: Boolean,
      default: false,
    },
    has_active_filters: {
      type: Boolean,
      default: false,
    },
    active_filter_count: {
      type: Number,
      default: 0,
    },
    is_private: {
      type: Boolean,
      default: false,
    },
  },
  emits: [
    'toggle_filters',
    'filter_change',
    'update:selected_deal_radio',
    'deal_selected',
    'edit_deal',
    'update_current_page',
    'delete_deal',
  ],
  methods: {
    forwardEditDeal(section, data) {
      this.$emit('edit_deal', section, data);
    },
  },
};
</script>

<style lang="scss" scoped>
.deals-filter-toggle {
  display: inline-flex;
  align-items: center;
  cursor: pointer;
  border: 1.5px solid #e5e7eb;
  border-radius: 20px;
  padding: 5px 14px;
  font-size: 0.85rem;
  background: #fff;
  transition: all 0.15s ease;
  user-select: none;

  &:hover {
    border-color: var(--primary, #7367f0);
    color: var(--primary, #7367f0);
  }

  .mr-05 {
    margin-right: 0.3rem;
  }

  .ml-05 {
    margin-left: 0.3rem;
  }
}
</style>